/* @minVersion 7.0.0-beta.0 */

// This function isn't mean to be called, but to be used as a reference.
// We can't use a normal object because it isn't hoisted.
export default function _temporalUndefined(this: never): void {}
